import { shallowEqual } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getCommissionStreamId } from '../helpers';
import { getCommissions } from '../selectors';
import { fetchMoreCommissions } from '../actions';

export type WithCommissionProps = {
  commissions: PapiDeviation[];
  isFetchingCommissions: boolean;
  hasMoreCommissions: boolean;
  isCommissionStreamInitialized: boolean;
  fetchMoreCommissions: () => void;
};

const mapStateToProps = state => {
  const streamId = getCommissionStreamId();
  const commissions = getCommissions(state);
  return {
    commissions,
    isFetchingCommissions: selectors.isFetching(state, streamId),
    isCommissionStreamInitialized: selectors.isInitialized(state, streamId),
    hasMoreCommissions: selectors.hasMore(state, streamId),
  };
};

export const useCommissions = (): WithCommissionProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({ fetchMoreCommissions }),
});
